import { render, staticRenderFns } from "./lvAside.vue?vue&type=template&id=d08aa5b0&scoped=true&"
import script from "./lvAside.vue?vue&type=script&lang=js&"
export * from "./lvAside.vue?vue&type=script&lang=js&"
import style0 from "./lvAside.vue?vue&type=style&index=0&id=d08aa5b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08aa5b0",
  null
  
)

export default component.exports